module.exports = __webpack_public_path__ + "img/six.5de3995f.gif";